module.exports = __webpack_public_path__ + "static/img/lengyin.2e09a4f0.png";